import { Component, inject, signal } from '@angular/core';

import { Router, RouterOutlet } from '@angular/router';
import { HighscoreModalComponent } from './highscore-modal/highscore-modal.component';
import { StatsModalComponent } from './stats-modal/stats-modal.component';
import { SettingsModalComponent } from './settings-modal/settings-modal.component';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    imports: [
    RouterOutlet,
    HighscoreModalComponent,
    StatsModalComponent,
    SettingsModalComponent,
    LoginComponent
],
    templateUrl: './app.component.html'
})
export class AppComponent {
  private router = inject(Router);
  private auth = inject(AuthService);

  isHighscores = signal(false);
  isStats = signal(false);
  isSettings = signal(false);
  // Displayed version info (can be updated per release)
  version = '1.8.0';
  versionDate = '14.07.2026';

  sessionLoaded = this.auth.loaded;
  requiresLogin = this.auth.requiresLogin;
  canManageUsers = this.auth.canManageUsers;
  currentUser = this.auth.currentUser;

  constructor() {
    this.auth.loadSession().subscribe({
      // Without a session answer we cannot tell internal from external, so play
      // it safe and ask for a login rather than showing the board.
      error: () => this.auth.loaded.set(true),
    });
  }

  goHome() { this.router.navigateByUrl('/'); }
  showHighscores() { this.isHighscores.set(true); }
  showStats() { this.isStats.set(true); }
  showSettings() { this.isSettings.set(true); }
  showHistory() { this.router.navigateByUrl('/history'); }

  logout() {
    this.auth.logout().subscribe({
      next: () => this.auth.loadSession().subscribe(),
      error: () => this.auth.loadSession().subscribe(),
    });
  }

  closeHighscores = () => this.isHighscores.set(false);
  closeStats = () => this.isStats.set(false);
  closeSettings = () => this.isSettings.set(false);
}
